<!-- 登录 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogReg"
      width="900px"
    >
      <el-row
        type="flex"
        :gutter="20"
        justify="space-between"
        align="middle"
      >
        <el-col :span="12">
          <div class="reg-box">
            <p class="regh1">
              立即注册
            </p>
            <p class="regText">
              立即注册为会员，获取最新的科学咨询，通过科学的管理方法提高团队工作效率。
              <br>VIP会员可以获得更多专业的服务。
            </p>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            status-icon
            :rules="rules"
            label-width="0px"
            class="demo-ruleForm"
          >
            <el-form-item
              label-width="0"
              prop="name"
            >
              <el-input
                v-model="ruleForm.name"
                class="ipth60"
                placeholder="请您输入姓名"
                autocomplete="off"
                :clearable="true"
              />
            </el-form-item>

            <el-form-item
              llabel-width="0"
              prop="phoneNumber"
            >
              <el-input
                v-model="ruleForm.phoneNumber"
                placeholder="手机号码"
                autocomplete="off"
                :clearable="true"
              />
            </el-form-item>
            <el-form-item
              label-width="0"
              prop="captchaResponse"
            >
              <el-input
                v-model="ruleForm.captchaResponse"
                placeholder="验证码"
                class="input-with-select"
                autocomplete="off"
                :clearable="true"
              >
                <el-button
                  slot="append"
                  @click="captchaFn"
                >
                  {{ countValue }}
                </el-button>
              </el-input>
            </el-form-item>

            <el-form-item
              llabel-width="0"
              prop="password"
            >
              <el-input
                v-model="ruleForm.password"
                type="password"
                autocomplete="off"
                :clearable="true"
              />
            </el-form-item>
            <el-form-item
              label-width="0"
              prop="checkPass"
            >
              <el-input
                v-model="ruleForm.checkPass"
                type="password"
                autocomplete="off"
                :clearable="true"
              />
            </el-form-item>

            <el-form-item class="flex">
              <el-row
                type="flex"
                class="row-bg"
                justify="center"
              >
                <el-col :span="11">
                  <el-button
                    class="w100"
                    type="primary"
                    @click="submitForm('ruleForm')"
                  >
                    注册并登陆
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>

import pathReq from '../../api/pathlist'
import { Message } from 'element-ui'

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validateCaptcha = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }

    return {
      dialogReg: false,
      countdown: 60,
      countValue: '获得验证码',
      flag: true,
      ruleForm: {
        name: '',
        captchaResponse: '',
        phoneNumber: '',
        password: '',
        checkPass: '',
        verificationCodeType: '1'
      },
      rules: {

        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        captchaResponse: [
          { validator: validateCaptcha, trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.$bus.off('show/reg')
    this.$bus.on('show/reg', () => {
      this.dialogReg = true
    })
  },

  methods: {
    handleClose() {
      this.dialogReg = false
    },

    captchaFn() {
      const path = '/api/services/app/MstSmsMessage/SendVerificationCodeMsg'
      if (this.ruleForm.phoneNumber !== '') {
        const codeData = {}
        codeData.phoneNumber = this.ruleForm.phoneNumber
        codeData.verificationCodeType = this.ruleForm.verificationCodeType

        pathReq.postForm(path, codeData).then((res) => {
          if (res.status === 200) {
            console.log(res.data)
            this.settime(60)
          }
        })
      } else {
        Message.error('手机号码不能为空')
      }
    },

    submitForm(formName) {
      // const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const path = '/api/services/app/Account/Register'
          pathReq.postForm(path, this.ruleForm).then((res) => {
            if (res.status === 200) {
              const canLogin = res.data.result.canLogin
              sessionStorage.setItem('isLogin', canLogin)
              window.localStorage.setItem('isLogin', canLogin)
              this.$bus.emit('data/show', canLogin)
              this.dialogReg = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    settime(countd) {
      const that = this
      let countdown = countd
      if (countdown === 0) {
        that.flag = true
        that.countValue = '获得验证码'
        countdown = 60
        return
      }
      that.flag = false
      that.countValue = `重新发送(${countdown})`
      countdown -= 1

      setTimeout(() => {
        that.settime(countdown)
      }, 1000)
    }
  }

}
</script>
<style scoped>
.w40 {
  width: 40%;
}

.w100 {
  width: 100%;
}

.reg-box {
  padding-left: 30px;
  transform: translateY(-50%);
}

.reg-box .regh1 {
  color: #2b9ddb;
  font-size: 50px;
  font-weight: 300;
}

.reg-box p.regText {
  color: #9dafbd;
  text-align: left;
}
</style>
